import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import ContactForm from "../components/ContactForm";
import { PAGE_UPDATED, webPageLd, breadcrumbLd } from "../data/site";

export default function ContactPage() {
  return (
    <>
      <Seo
        title="Contact & Free Estimates Austin TX | Texan Strong Builds"
        description="Request a free written estimate from Texan Strong Builds — concrete patios, driveways, stamped concrete & xeriscape in Austin TX. Call (512) 781-8851."
        canonical={`${window.location.origin}/contact`}
        jsonLd={[
          webPageLd({
            name: "Contact Texan Strong Builds | Free Concrete & Landscape Estimate Austin TX",
            path: "/contact",
            updated: PAGE_UPDATED.contact,
            description: "Request a free written estimate from Texan Strong Builds in Austin, TX.",
            type: "ContactPage",
          }),
          breadcrumbLd([
            { name: "Home", path: "/" },
            { name: "Contact", path: "/contact" },
          ]),
        ]}
      />

      <section className="bg-stone-900 text-white pt-32 pb-12 lg:pt-40">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Breadcrumbs dark items={[{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }]} />
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-red-500">Contact</div>
          <h1 className="mt-4 font-display text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95]">
            Tell us about<br />your project.
          </h1>
          <p className="mt-6 text-stone-300 text-lg max-w-2xl">
            Written estimates within 48 hours. No high-pressure sales. Just measurements,
            options, and a fair price.
          </p>
        </div>
      </section>

      <ContactForm compact />
    </>
  );
}
